import combineReducers from 'combine-reducers-global-state';
import merge from 'lodash/merge';
import { userTypes } from 'redux/user';
import NotificationService from 'services/notificationService';
import { workspaceTypes } from 'redux/workspace';
import authTypes from './types';

const setNotificationsCount = (count) => {
  NotificationService.firebase.setBadgeNumber(count || 0);
};

// Null only when initiated
const isLoggedIn = (state = null, { type }) => {
  switch (type) {
    case authTypes.getAuthUserSuccess:
      return true;
    case authTypes.logoutSuccess:
    case authTypes.loginFailure:
    case authTypes.refreshTokenFailure:
      return false;
    default:
      return state;
  }
};

const intercom = (state = {}, { type, payload }) => {
  switch (type) {
    case authTypes.getAuthUserSuccess:
      return { ...payload.intercom };
    default:
      return state;
  }
};

const user = (state = {}, { type, payload }) => {
  switch (type) {
    case authTypes.loginFailure:
    case authTypes.refreshTokenFailure:
    case authTypes.logoutSuccess:
      return {};
    case authTypes.getAuthUserSuccess:
      return merge({}, state, payload.user);

    case userTypes.getBadgesSuccess:
      setNotificationsCount(payload.notifications);
      return { ...state, notificationCount: payload.notifications };

    case authTypes.getProfileSuccess:
    case userTypes.updateProfileSuccess:
      return merge({}, state, payload);

    // TODO: Notification handling to a separate reducer
    case userTypes.newNotification:
      setNotificationsCount((state.notificationCount || 0) + 1);
      return merge({}, state, { notificationCount: (state.notificationCount || 0) + 1 });

    case userTypes.readNotificationsSuccess:
      setNotificationsCount(0);
      return merge({}, state, { notificationCount: 0 });

    case userTypes.changeLanguageSuccess:
      return { ...state, locale: payload };

    default:
      return state;
  }
};

const fallbackWorkspace = {};
const workspace = (state = fallbackWorkspace, { type, payload }) => {
  switch (type) {
    // name, color, locale, logo, custom greeting
    case workspaceTypes.getWorkspaceSettingsSuccess:
    case workspaceTypes.updateWorkspaceSettingsSuccess:
      return merge({}, state, payload);
    case authTypes.getAuthUserSuccess:
      return payload.workspace || fallbackWorkspace;
    default:
      return state;
  }
};

// What workspace/{workspace}/me answers: permissions, features and integrations of the member in that workspace
const member = (state = null, { type, payload }) => {
  switch (type) {
    case authTypes.getMemberSuccess:
      return payload;
    case authTypes.logoutSuccess:
    case authTypes.loginFailure:
    case authTypes.refreshTokenFailure:
      return null;
    default:
      return state;
  }
};

const authReducer = combineReducers({
  isLoggedIn,
  user,
  intercom,
  workspace,
  member,
});

export default { auth: authReducer };
